// This file is auto-generated by scripts/generate-custom-pages-registry.ts
// Do not edit manually - changes will be overwritten

import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

import { type PageComponentProps } from '@typings/components/page'

export type CustomPageComponent = ComponentType<PageComponentProps> | ComponentType<{}>

const agentProfileComponent = dynamic(() => import('@custom/pages/agent-profile/page'))
const agentSearchComponent = dynamic(() => import('@custom/pages/agent-search/page'))
const agentStoreComponent = dynamic(() => import('@custom/pages/agent-store/page'))
const customPageExampleComponent = dynamic(() => import('@custom/pages/custom-page-example/page'))
const homepageComponent = dynamic(() => import('@custom/pages/homepage/page'))
const plansComponent = dynamic(() => import('@custom/pages/plans/page'))
const superhumanGoIntroComponent = dynamic(() => import('@custom/pages/superhuman-go-intro/page'))

export interface CustomPageRegistry {
  [slug: string]: CustomPageComponent
}

// Registry mapping slugs to their custom components (dynamic imports for code splitting)
export const customPageRegistry: CustomPageRegistry = {
  '/agent-profile': agentProfileComponent,
  '/agent-search': agentSearchComponent,
  '/agent-store': agentStoreComponent,
  '/custom-page-example': customPageExampleComponent,
  '/': homepageComponent,
  '/plans': plansComponent,
  '/superhuman-go-intro': superhumanGoIntroComponent,
}

// Available custom page slugs
export const customPageSlugs = Object.keys(customPageRegistry)
